export enum TextureKinds {
  None = 0,
  GrayDiagonalCross = 1,
  Fill = 2,
  LinesFromTopLeft = 3,
  LinesFromTopRight = 4,
  SmallDot = 5,
  LargeDot = 6,
  LinesFromTop = 7,
  LinesFromLeft = 8,
  DiagonalCross = 9,
  Cross = 10
}
